import { freeLabelColor } from "../../utils/categoricalColors";
export interface IProps {
	text: string;
}

export const HashStringIcon = ({ text }: IProps) => {
	return (
		<span
			style={{
				width: 8,
				height: 8,
				borderRadius: "50%",
				backgroundColor: freeLabelColor(text).dot,
			}}
		/>
	);
};
